import { DEVICE_WIDTHS } from '@amzn/carrierlogistics-commons/dist/constants/breakpoints';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Responsive from '@amzn/meridian/responsive';
import Row from '@amzn/meridian/row';
import { SideMenuLink } from '@amzn/meridian/side-menu';
import Text from '@amzn/meridian/text';
import { css } from '@emotion/css';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { sideNavSupportItemsExternal } from '../config/sideMenuNavItems';
import FeedbackModule from '../containers/FeedbackModule';
import InlineHelpModule from '../containers/InlineHelpModule';

export const SupportNavMenu = () => {
  const { pathname = '' } = useLocation();
  const history = useHistory();

  const handleRouting = (link) => {
    history.push(link);
  };
  if (sideNavSupportItemsExternal?.every(({ isDisabled }) => isDisabled)) return null;
  return (
    <Responsive
      query="min-width"
      props={{
        isSmallScreen: {
          default: true,
          [DEVICE_WIDTHS.DESKTOP]: false,
        },
      }}
    >
      {({ isSmallScreen }) => (
        <Column
          className={css`
            & {
              padding: 0px;
              padding-top: 1rem;
            }
          `}
          spacingInset="small"
          spacing="small"
          alignment="bottom"
        >
          <Text>
            <FormattedMessage id="support" />
          </Text>
          <Divider />
          <div
            className={css`
              & {
                list-style: none;
              }
            `}
            style={{ listStyle: 'none' }}
          >
            {sideNavSupportItemsExternal.map(({ link, isDisabled, label }) => (
              <SideMenuLink
                key={link}
                selected={pathname.includes(link)}
                onClick={() => handleRouting(link)}
                disabled={isDisabled}
              >
                <FormattedMessage id={label} />
              </SideMenuLink>
            ))}

            {isSmallScreen && (
              <Row
                alignmentVertical="center"
                spacingInset="300 0 0 0"
                alignmentHorizontal="center"
                widths={['40%', '8%', '40%']}
              >
                <FeedbackModule />
                <div
                  className={css`
                    width: 2px; 
                    height: 30px;
                    background-color: white; 
                  `}
                />
                <InlineHelpModule />
              </Row>
            )}
          </div>
        </Column>
      )}
    </Responsive>
  );
};

export default SupportNavMenu;
